import { getRequest } from 'utils/api/apiRequest'
import { WithPagination } from 'utils/api/pagination'
import { CatalogProduct } from 'utils/api/Products/CatalogProduct'

export const fetchExpensivestProducts = () =>
  getRequest<WithPagination<CatalogProduct>>('/redemption-site/products?limit=1&sort[product.shop_price]=DESC')
